export function resolveMainSectionId(main_section, fallback_index = null) {
  const raw_main_section_id = main_section?.main_section_id ?? main_section?.id ?? main_section?.backend_id ?? fallback_index ?? null;
  return Number(raw_main_section_id);
}

export function resolveFormMainSectionId(main_section, fallback_index = null) {
  const raw_main_section_id = main_section?.form_main_section_id
    ?? main_section?.id
    ?? main_section?.backend_id
    ?? fallback_index
    ?? null;
  return Number(raw_main_section_id);
}

export function resolveSubSectionId(sub_section, fallback_index = null) {
  const raw_sub_section_id = sub_section?.form_section_id
    ?? sub_section?.section_id
    ?? sub_section?.backend_id
    ?? sub_section?.id
    ?? fallback_index
    ?? null;
  return Number(raw_sub_section_id);
}

export function resolveQuestionId(question, fallback_index = null) {
  const raw_question_id = question?.question_id ?? question?.backend_id ?? question?.id ?? fallback_index ?? null;
  return Number(raw_question_id);
}

function isIndexWithinReorderRange(index, items) {
  return index >= 0 && index < items.length;
}

function areReorderIndexesWithinRange(lowest_index, highest_index, items) {
  return isIndexWithinReorderRange(lowest_index, items)
    && isIndexWithinReorderRange(highest_index, items);
}

export function isValidReorderRange(source_index, target_index, items) {
  const lowest_index = Math.min(source_index, target_index);
  const highest_index = Math.max(source_index, target_index);
  return source_index !== target_index
    && areReorderIndexesWithinRange(lowest_index, highest_index, items);
}

export function moveItemByIndex(items, source_index, target_index) {
  const reordered_items = [...items];
  const [moved_item] = reordered_items.splice(source_index, 1);
  if (!moved_item) return null;
  reordered_items.splice(target_index, 0, moved_item);
  return { moved_item, reordered_items };
}

export function buildMainSectionReorderPayload(form_id, reordered_sections) {
  const payload = {
    form_id: form_id,
    reordered_main_sections: reordered_sections.map((item, index) => ({
      main_section_id: resolveMainSectionId(item),
      order_number: index + 1,
    })),
  };
  return payload;
}
